// components/LubeOilROBDetailsTable.tsx
import React from 'react';
import { Label } from 'reactstrap';

interface LubeOilROBDetailsTableProps {
    lubeOilName: string;
    previousROB: number;
    bunkered: number;
    debunkered: number;
    consumed: number;
    adjustment: number;
    currentROB: number;
}

const LubeOilROBDetailsTable: React.FC<LubeOilROBDetailsTableProps> = ({
    lubeOilName,
    previousROB,
    bunkered,
    debunkered,
    consumed,
    adjustment,
    currentROB,
}) => {
    return (
        <table className="w-50">
            <thead>
                <tr>
                    <th className="text-left truncate" colSpan={2}>
                        <span className="inline-block max-w-full">{lubeOilName}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="pr-4">
                        <Label className="small-unit-size mb-0 w-7">ROB(last report):&nbsp;</Label>
                    </td>
                    <td className="text-right">
                        <b className="small-unit-size color-green">{previousROB.toFixed(4)}</b>
                    </td>
                </tr>
                <tr>
                    <td className="pr-4">
                        <Label className="small-unit-size mb-0 w-7">Bunkered Qty:&nbsp;</Label>
                    </td>
                    <td className="text-right">
                        <b className="small-unit-size color-green">{bunkered.toFixed(4)}</b>
                    </td>
                </tr>
                <tr>
                    <td className="pr-4">
                        <Label className="small-unit-size mb-0 w-7">Debunkered Qty:&nbsp;</Label>
                    </td>
                    <td className="text-right">
                        <b className={`small-unit-size ${debunkered === 0 ? "color-green" : "color-red"}`}>{`${debunkered > 0 ? "-" : ""}${(debunkered)?.toFixed(4)}`}</b>
                    </td>
                </tr>
                <tr>
                    <td className="pr-4">
                        <Label className="small-unit-size mb-0 w-7">Consumption:</Label>
                    </td>
                    <td className="text-right">
                        <b className={`small-unit-size ${(consumed) === 0 ? "color-green" : "color-red"}`}>{`${consumed > 0 ? "-" : ""}${consumed.toFixed(4)}`}</b>
                    </td>
                </tr>
                <tr>
                    <td className="pr-4">
                        <Label className="small-unit-size mb-0 w-7">Adjustments:&nbsp;</Label>
                    </td>
                    <td className="text-right">
                        <b className={`small-unit-size ${adjustment >= 0 ? 'color-green' : 'color-red'}`}>
                            {adjustment.toFixed(4)}
                        </b>
                    </td>
                </tr>
                <tr id={`lube_oil_rob`}>
                    <td className="pr-12">
                        <Label className="small-unit-size mb-0 w-7">ROB(current):&nbsp;</Label>
                    </td>
                    <td className="text-right">
                        <b className="small-unit-size">{currentROB.toFixed(4)}</b>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default LubeOilROBDetailsTable;
